import { useCallback, useEffect } from 'react';

export const useKey = (key: string, onTrigger: () => void) => {
  const handle = useCallback(
    (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === key) {
        event.preventDefault();
        onTrigger();
      }
    },
    [key, onTrigger]
  );

  useEffect(() => {
    document.addEventListener('keydown', handle);
    return () => document.removeEventListener('keydown', handle);
  }, [handle]);
};
